<template>
  <div class="slider banner-slider">
    <div class="proposal-title-wrapper" v-if="title">
      <h2
        v-html="title"
        class="proposal-title white--text secondary lighten-1 text-uppercase mb-3"
      ></h2>
    </div>
    <swiper :options="swiperOption" ref="swiperRef">
      <swiper-slide
        v-for="proposal in proposals"
        :key="proposal.id"
        :ref="swiperRef"
      >
        <ProposalImage :proposal="proposal" />
      </swiper-slide>
    </swiper>
    <div
      v-if="showBullets && proposals.length > 1"
      :id="`banner-pagination-${paginationClass}`"
      :class="`swiper-pagination banner-pagination-${paginationClass}`"
    ></div>
    <div
      v-if="showArrows && proposals.length > 1"
      :id="`banner-slider-prev-${paginationClass}`"
      :class="`swiper-button-prev banner-slider-prev-${paginationClass}`"
    ></div>
    <div
      v-if="showArrows && proposals.length > 1"
      :id="`banner-slider-next-${paginationClass}`"
      :class="`swiper-button-next banner-slider-next-${paginationClass}`"
    ></div>
  </div>
</template>
<script>
import ProposalImage from "./ProposalImage.vue";

import deliveryReactive from "~/mixins/deliveryReactive";
export default {
  name: "ProposalSlider",
  props: {
    title: { type: String, required: false },
    proposals: { type: Array, required: true },
    paginationClass: { type: String, default: "swiper-pagination-banner" },
    cols: { default: 1 },
    sm: { default: 1 },
    md: { default: 1 },
    lg: { default: 1 },
    xl: { default: undefined },
    showArrows: { type: Boolean, default: false },
    showBullets: { type: Boolean, default: true }
  },
  components: { ProposalImage },
  mixins: [deliveryReactive],
  data() {
    return {
      swiperRef: null,
      swiperOption: {
        slidesPerGroup: 1,
        spaceBetween: 20,
        watchOverflow: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: `.banner-pagination-${this.paginationClass}`,
          clickable: true
        },
        navigation: {
          prevEl: `.banner-slider-prev-${this.paginationClass}`,
          nextEl: `.banner-slider-next-${this.paginationClass}`
        },
        breakpoints: {
          0: {
            slidesPerView: this.cols
          },
          600: {
            slidesPerView: this.sm
          },
          960: {
            slidesPerView: this.md
          },
          1264: {
            slidesPerView: this.lg
          },
          1904: {
            slidesPerView: this.xl || this.lg
          }
        }
      }
    };
  },
  methods: {
    reload() {
      if (this.$refs.swiperRef.swiperInstance) {
        this.$refs.swiperRef.swiperInstance.slideTo(0);
      }
    }
  }
};
</script>
